"use client" 
import Select from "react-select"
import makeAnimated from 'react-select/animated'

import { useState, useEffect } from "react"
import sectors from "../../../json/sectors"
import useSelectStyles from "./Styles"



const SectorSelect = ({isMulti, onChange, placeholder, id, name, target, callback, lang, required, missingRequired, parent, parentField}) => {

// console.log("TARGET", target)

     const animatedComponents = makeAnimated();


     const [isClient, setIsClient] = useState(false)
     const [data, setData] = useState(null);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);
     const [isClearable, setIsClearable] = useState(true);
     const [isSearchable, setIsSearchable] = useState(true);
     const [isDisabled, setIsDisabled] = useState(false);
     const [isLoading, setIsLoading] = useState(false);
     const [isRtl, setIsRtl] = useState(false);
     const [selectedSectors, setSelectedSectors] = useState([])
     const [associatedSectors, setAssociatedSectors] = useState()

     const handleChange = async (x) => {
      setSelectedSectors(x)
      callback(x)
      onChange(x)
     }
     

     useEffect(() => {
       setIsClient(true)
      // console.log("TARGETPAR", target, parentField)
      if (target && target[parentField]) {
      // console.log('tarTAgs', target.tags)
      let sectorsAssociated = [];
      let sectorsArr = Array.isArray(target[parentField]) ? target[parentField] : [target[parentField]]
      for (let sector of sectorsArr) {
        sectorsAssociated.push({ id: sector.id, value: sector.value, label_en: sector.label_en, label_fr: sector.label_fr });
      }
      setAssociatedSectors(sectorsAssociated);
    }
     }, [target]) // remove target if things stop working


// const inputFieldValue = () => {
//   let value = null;

//   if (isMulti) {
//     if (selectedSectors?.length) {
//       value = selectedSectors.map(sector => ({
//         id: sector.id,
//         value: sector.value,
//         label: sector[`label_${lang}`],
//         label_en: sector.label_en,
//         label_fr: sector.label_fr,
//       }));
//     } else if (associatedSectors?.length) {
//       value = associatedSectors.map(sector => ({
//         id: sector.id,
//         value: sector.value,
//         label: sector[`label_${lang}`],
//         label_en: sector.label_en,
//         label_fr: sector.label_fr,
//       }));
//     }
//   } else {
//     if (selectedSectors) {
//       value = selectedSectors;
//       console.log('selectedsectors', selectedSectors)
//     } else if (target?.[parentField]) {
//       // value = {...associatedSectors};
//       value = {id: 1, value: 'test', label_en: 'test', label_fr: 'test'}
//       console.log('leval', value)
//             console.log('associatedsectors', associatedSectors)
//       // value = {
//       //   id: target[parentField]['id'],
//       //   value: target[parentField].value,
//       //   label_en: target[parentField][`label_en`],
//       //   label_en: target[parentField][`label_fr`],
//       //   // label: target[parentField][`label_${lang}`],
//       // };
   
//     }
//   }

//   return value;
// };
     
const inputFieldValue = () => {
  // MULTI SELECT
  if (isMulti) {
    if (selectedSectors.length > 0) {
      return selectedSectors.map(sector => ({
        value: sector.value,
        label: sector[`label_${lang}`],
        ...sector,
      }));
    }

    if (associatedSectors?.length > 0) {

      return associatedSectors.map(sector => ({
        value: sector.value,
        label: sector[`label_${lang}`],
        ...sector,
      }));
    }

    return [];
  }

  // SINGLE SELECT
  if (selectedSectors && !Array.isArray(selectedSectors)) {
    return {
      value: selectedSectors.value,
      label: selectedSectors[`label_${lang}`],
      ...selectedSectors,
    };
  }

  if (target?.[parentField]) {
    return {
      value: target[parentField].value,
      label: target[parentField][`label_${lang}`],
      ...target[parentField],
    };
  }

  return null;
};

 
if (!isClient) {
     return null
}
     return (
          <>
          {/* {console.log("TRGT", target?.[`${parent.toLowerCase()}_sector_industry`]?.value)} */}
          
          <Select
          required={required}
            // className={`w-full ${missingRequired && 'border border-red-400 dark:border-red-600'} dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start`}

            className={`w-full ${missingRequired && 'border border-red-400 dark:border-red-600 rounded-lg'} dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}



            classNamePrefix="select"

          //   defaultValue={colourOptions[0]}
            isDisabled={isDisabled}
            isLoading={isLoading}
            isClearable={isClearable}
            isRtl={isRtl}
            isSearchable={isSearchable}
            name={name}
            id={id}
            isMulti={isMulti}
            onChange={handleChange}
            // value={selectedSector || target && {value: target?.[`${parent.toLowerCase()}_sector_industry`]?.value, label: target?.[`${parent.toLowerCase()}_sector_industry`]?.[`label_${lang}`]} || null}
            value={
              inputFieldValue()
    //           !isMulti ? selectedSectors :
    // selectedSectors.length
    // ? selectedSectors.map(sector => ({
    //     id: sector.id,
    //     value: sector.value,
    //     label: sector[`label_${lang}`],
    //     label_en: sector.label_en,
    //     label_fr: sector.label_fr
    //   }))
    // : isMulti && associatedSectors
    //   ? associatedSectors.map(sector => ({
    //       id: sector.id,
    //       value: sector.value,
    //       label: sector[`label_${lang}`],
    //       label_en: sector.label_en,
    //       label_fr: sector.label_fr
    //     }))
    //   : !isMulti && target?.[parentField]
    //     ? {
    //         value: target[parentField].value,
    //         label: target[parentField][`label_${lang}`]
    //       }
    //     : null
}
            // value={selectedSectors.map(sector => {return {id: sector.id, value: sector.value, label: sector[`label_${lang}`], label_en: sector.label_en, label_fr: sector.label_fr}}) || target && isMulti ? associatedSectors?.map(sector => {return {id: sector.id, value: sector.value, label: sector[`label_${lang}`], label_en: sector.label_en, label_fr: sector.label_fr}}) : target && {value: target?.[parentField]?.value, label: target?.[parentField]?.[`label_${lang}`]} || null}
            options={
              sectors.map(sector => {return {id: sector.id, value: sector.value, label: sector[`label_${lang}`], label_en: sector.label_en, label_fr: sector.label_fr}})
            }
            components={animatedComponents}
            placeholder={placeholder}
            styles={useSelectStyles()}
          />
    

        </>
     
     )
}

export default SectorSelect





























// v1
// "use client" 
// import Select from "react-select"
// import makeAnimated from 'react-select/animated'

// import { useState, useEffect } from "react"
// import sectors from "../../../json/sectors"
// import Styles from "./Styles"



// const SectorSelect = ({isMulti, onChange, placeholder, id, name, target, callback, lang, required, missingRequired, parent}) => {

//      const animatedComponents = makeAnimated();
    
//      const [isClient, setIsClient] = useState(false)
//      const [data, setData] = useState(null);
//      const [loading, setLoading] = useState(true);
//      const [error, setError] = useState(null);
//      const [isClearable, setIsClearable] = useState(true);
//      const [isSearchable, setIsSearchable] = useState(true);
//      const [isDisabled, setIsDisabled] = useState(false);
//      const [isLoading, setIsLoading] = useState(false);
//      const [isRtl, setIsRtl] = useState(false);
//      const [selectedSector, setSelectedSector] = useState(null)

//      const handleChange = async (x) => {
//       setSelectedSector(x)
//       callback(x)
//       onChange(x)
//      }
    
//      useEffect(() => {
//        setIsClient(true)
//      }, [])
     

//      if (!isClient) {
//       return null;
//      }
  
 
//     //  const getValue = (parent, isMulti) => {
//     //   if (target && isMulti === true) { 
       
//     //     let obj = Array.isArray(target.user_sector_industry) ? target.user_sector_industry.map(x=> {
//     //       return { 
//     //       id: x.id,
//     //       value: x.value || '',  
//     //       label: x.label_en,
//     //       label_en: x.label_en,
//     //       label_fr: x.label_fr
//     //     }
//     //       }) : {}
//     //     return selectedSector || obj
//     //   // }
//     //   //   else { return {value: '', label: ''}}
//     //   }
//     //   else if (target && isMulti === false) {
//     //     return selectedSector || {value: target?.[`${parent.toLowerCase()}_sector_industry`]?.value, label: target?.[`${parent.toLowerCase()}_sector_industry`]?.[`label_${lang}`]}
//     //   }
//     //   else { 
//     //     return ''
//     //   }
//     //  }
//   // uncomment above is breaks
//     const getValue = (parent, isMulti) => {
//       if (target && isMulti === true) {
//         let obj = Array.isArray(target.user_sector_industry) ? target.user_sector_industry.map((x) => ({
//               id: x.id,
//               value: x.value || '',
//               label: x.label_en,
//               label_en: x.label_en,
//               label_fr: x.label_fr,
//             }))
//           : [];
    
//         return selectedSector || obj;
//       } else if (target && isMulti === false) {
//         return (
//           selectedSector ||
//           (target[`${parent.toLowerCase()}_sector_industry`]
//             ? {
//                 value: target[`${parent.toLowerCase()}_sector_industry`]?.value || '',
//                 label:
//                   target[`${parent.toLowerCase()}_sector_industry`]?.[
//                     `label_${lang}`
//                   ] || '',
//               }
//             : null)
//         );
//       } else {
//         return selectedSector || (isMulti ? [] : null);
//       }
//     };
     

//      return (
//           <>
//           <Select
//           required={required}
//             // className={`w-full ${missingRequired && 'border border-red-400 dark:border-red-600'} dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start`}

//             className={`w-full ${missingRequired && 'border border-red-400 dark:border-red-600'} dark:bg-inherit appearance-none inner-shadow rounded px-0 text-slate-700 leading-tight rounded-lg focus:outline-none focus:shadow-outline`}



//             classNamePrefix="select"

//           //   defaultValue={colourOptions[0]}
//             isDisabled={isDisabled}
//             isLoading={isLoading}
//             isClearable={isClearable}
//             isRtl={isRtl}
//             isSearchable={isSearchable}
//             name={name}
//             id={id}
//             isMulti={isMulti}

//             onChange={(x)=>handleChange(x)}
//             // value={selectedSector || target && {value: target?.[`${parent.toLowerCase()}_sector_industry`]?.value, label: target?.[`${parent.toLowerCase()}_sector_industry`]?.[`label_${lang}`]} || null}
//             value={getValue(parent, isMulti)}
//             options={
//               sectors.map(sector => {return {id: sector.id, value: sector.value, label: sector[`label_${lang}`], label_en: sector.label_en, label_fr: sector.label_fr}})
//             }
//             // components={animatedComponents}
//             placeholder={placeholder}
//             styles={Styles()}
//           />
    

//         </>
     
//      )
// }

// export default SectorSelect